import { createFileRoute, Outlet } from "@tanstack/react-router"
import { checkPermissions } from "@/utils/checkPermissions"
import { DetailSidebar, LayoutWithSidebar } from "toptaal-shared"
import ScreenWrapper from "@/components/ScreenWrapper"
import LocationDetailSidebar from "@/pages/locaties/LocationDetailSidebar"

export const Route = createFileRoute("/beheer/locaties/$locationId")({
  component: Parent,
  beforeLoad: () => checkPermissions("read", "locations"),
})

function Parent() {
  return (
    <ScreenWrapper className="!px-0">
      <LayoutWithSidebar
        sidebar={
          <DetailSidebar goBackLabel="Locaties" goBackRoute="/beheer/locaties">
            <LocationDetailSidebar />
          </DetailSidebar>
        }
      >
        <Outlet />
      </LayoutWithSidebar>
    </ScreenWrapper>
  )
}
